
import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

export function load(apiKey) {
    if (!(typeof google !== 'undefined' && !!google.maps && !!google.maps.importLibrary)) {
        setOptions({
            key: apiKey,
            v: "weekly",
        });
    }
    let pr_1;
    const pr = importLibrary("maps");
    pr_1 = (pr.then((_arg) => importLibrary("marker")));
    return pr_1.then((value) => {
    });
}

